/**
 * Prices on delapresse.fr are in euros only, in every language. The EUR
 * amounts mirror the database (packages.price_cents, setup_fees,
 * credit_packs); formatting follows the UI locale.
 */
import type { Locale } from "@/lib/locale";
import { intlLocale } from "@/lib/locale";

export type Currency = "EUR";
export const CURRENCY: Currency = "EUR";

/** Format a cents amount in euros for the UI locale. */
export function formatMoney(cents: number, locale: Locale, opts: { fraction?: boolean } = {}): string {
  return new Intl.NumberFormat(intlLocale(locale), {
    style: "currency",
    currency: CURRENCY,
    maximumFractionDigits: opts.fraction ? 2 : 0,
    minimumFractionDigits: opts.fraction ? 2 : 0,
  }).format(cents / 100);
}

export type PlanPriceSlug = "starter" | "growth" | "network" | "agency" | "enterprise";
export type CreditPackSku = "pack_500" | "pack_2000" | "pack_5000" | "pack_15000";

export const PLAN_MONTHLY_EUR: Record<PlanPriceSlug, number | null> = {
  starter: 7900,
  growth: 19900,
  network: 59900,
  agency: 99900,
  enterprise: null,
};

export const PLAN_SETUP_EUR: Record<PlanPriceSlug, number | null> = {
  starter: 4900,
  growth: 29900,
  network: 79900,
  agency: 149900,
  enterprise: 249900,
};

export const CREDIT_PACK_EUR: Record<CreditPackSku, number> = {
  pack_500: 1900,
  pack_2000: 5900,
  pack_5000: 12900,
  pack_15000: 32900,
};

export function planMonthlyCents(slug: PlanPriceSlug): number | null {
  return PLAN_MONTHLY_EUR[slug];
}
export function planSetupCents(slug: PlanPriceSlug): number | null {
  return PLAN_SETUP_EUR[slug];
}
export function creditPackCents(sku: CreditPackSku): number {
  return CREDIT_PACK_EUR[sku];
}

/** Annual billing: 12 months for the price of 10, shown as a monthly equivalent. */
export function annualMonthlyEquivalentCents(monthlyCents: number): number {
  return Math.round((monthlyCents * 12 * 0.83) / 12);
}
